//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import preview from '@/components/mobile-preview'

export default {
  // components: { preview },
  props: {
    content: {
      type: Object,
      default: function _default() {
        return {
          title: '',
          content: ''
        };
      }
    }
  },
  data: function data() {
    return {
      visible: false
    };
  },
  methods: {
    handleClose: function handleClose() {
      this.visible = false;
    }
  }
};